import React, { useState } from "react";
import DatePicker, { registerLocale } from 'react-datepicker';
import pl from "date-fns/locale/pl";
import "react-datepicker/dist/react-datepicker.css";

import styles from '@/views/pages/Template/Template.module.scss';

registerLocale("pl", pl);

const TemplateUseFormCalendar = ({ onChange }) => {
	const [ startDate, setStartDate ] = useState(null);

	return (
		<DatePicker
			className={ styles['template-use-form--datepicker'] }
			selected={ startDate }
			onChange={ date => {
				setStartDate(date);
				onChange(`${('0'+date.getDate()).slice(-2)}.${('0'+(date.getMonth() + 1)).slice(-2)}.${date.getFullYear()}`);
			} }
			dateFormat='dd.MM.yyyy'
			locale='pl'
			placeholderText='np. 22.03.2021'
		/>
	);
};
export default TemplateUseFormCalendar;